import '@tencent/exeditor3-ui-kit/dist/toolbar-select.js';
import { defaultOption } from './data.js';
import { dropdownIcon } from './icon.js';
// 防止XSS过滤
const xssStringFilter = (val) => {
    const pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
    let rs = '';
    for (let i = 0; i < val.length; i++) {
        rs = rs + val.substring(i, i + 1).replace(pattern, '');
    }
    return rs;
};
// 对象数组去重排序生成新的配置
const unique = (defaultvalue, arr) => {
    const res = new Map();
    // 去重
    const arroptions = arr.options.filter((arr) => !res.has(arr.label) && res.set(arr.label, 1));
    // 按照首字母排序
    arroptions === null || arroptions === void 0 ? void 0 : arroptions.sort((a, b) => `${a.label}`.localeCompare(`${b.label}`));
    const newOption = {
        default: defaultvalue,
        options: arroptions,
    };
    return newOption;
};
export class FontFamilyPlugin {
    constructor(opt = {}, overriderDefconfig) {
        var _a;
        this.name = 'fontFamily';
        this.defaultname = { label: '默认字体', value: 'initial' };
        this.get = () => this.editor.selection().getMarkAttrs(this).family;
        this.set = (family) => {
            if (family) {
                this.editor.selection().addMark(this, { family });
            }
            else {
                this.editor.selection().removeMark(this);
            }
        };
        this.clear = () => this.editor.selection().removeMark(this);
        this.canApply = () => this.editor.selection().canToggleMark(this);
        if (overriderDefconfig) {
            (_a = opt.options) === null || _a === void 0 ? void 0 : _a.unshift(this.defaultname);
            this.opt = {
                ...defaultOption,
                ...opt,
            };
        }
        else if (opt.options && opt.default) {
            for (let i = 0; i < opt.options.length; i++) {
                defaultOption.options.push(opt.options[i]);
            }
            const newOption = unique(opt.default, defaultOption);
            for (let i = 0; i < newOption.options.length; i++) {
                if (newOption.options[i].value === 'normal') {
                    newOption.options.splice(i, 1);
                    newOption.options.unshift(this.defaultname);
                    break;
                }
            }
            this.opt = {
                ...newOption,
            };
        }
        else {
            this.opt = {
                ...defaultOption,
            };
        }
        this.spec = {
            type: 'mark',
            matchStyle: {
                'font-family': (family) => xssStringFilter(family) ? { family } : false,
            },
            attrs: {
                family: {
                    toDOMAttribute: (family) => family ? { style: `font-family: ${family}` } : null,
                },
            },
            toDOM: 'span',
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            // 定义操作
            commands: {
                set: this.set,
                get: this.get,
                clear: this.clear,
            },
            // 定义快捷键
            shortcuts: {},
        };
    }
    // 自定义菜单按钮
    renderToolbarItem(ctx) {
        const t = this.editor.t.bind(this.editor);
        const select = document.createElement('exeditor-toolbar-select');
        select.label = ctx.in === 'dropdown' ? '' : this.editor.t('字体');
        const textWrapper = document.createElement('span');
        Object.assign(textWrapper.style, {
            display: 'inline-block',
            overflow: 'hidden',
            width: '6em',
            padding: '0 5px',
            'text-align': 'left',
            'text-overflow': 'ellipsis',
        });
        textWrapper.textContent = this.opt.default;
        const iconWrapper = document.createElement('span');
        iconWrapper.innerHTML = ctx.in === 'dropdown' ? '' : dropdownIcon;
        const wrapper = document.createElement('span');
        wrapper.append(textWrapper, iconWrapper);
        Object.assign(wrapper.style, {
            display: 'flex',
            'align-items': 'center',
        });
        select.append(wrapper);
        this.opt.options.forEach((entry) => {
            const option = document.createElement('exeditor-toolbar-option');
            const span = document.createElement('span');
            span.style.fontFamily = entry.value;
            span.textContent = t(entry.label);
            option.slot = 'option';
            option.value = entry.value;
            option.append(span);
            option.onclick = () => {
                this.editor.focus();
                this.set(entry.value);
            };
            select.appendChild(option);
        });
        const valToLable = (val) => {
            var _a;
            return (((_a = this.opt.options.find((entry) => {
                return val === entry.value;
            })) === null || _a === void 0 ? void 0 : _a.label) || '');
        };
        const setBtnProps = () => {
            const family = this.get();
            select.active = Boolean(family);
            select.value = family || this.opt.default;
            textWrapper.textContent = t(valToLable(select.value));
            select.disabled = !this.canApply();
        };
        setBtnProps();
        this.editor.on('idlechange', setBtnProps);
        return select;
    }
}
//# sourceMappingURL=index.js.map